<template>
  <a-modal
    :visible="visible.assess"
    width="900px"
    title="原料评估"
    :bodyStyle="{padding:'10px'}"
    @cancel="toggleVisible('assess')"
  >
    <a-row type="flex" slot="footer" justify="space-between">
      <a-button key="submit" type="primary" :loading="downloading" @click="ok">下载</a-button>
      <a-button key="back" @click="toggleVisible('assess')">关闭 </a-button>
    </a-row>
    <resize-table
      :columns="columns"
      bordered
      :scroll="{ x:0, y: 450 }"
      :loading="tableLoading"
      :data-source="list.records"
      :row-key="record => record.id"
      :pagination="false"
    >
      <template slot="rawName" slot-scope="text,record">
        {{overseasFlag == '1' ? (record.aliasName || text) : text}}
      </template>
      <span slot="uasge" slot-scope="text">{{text == null ? text : text.toFixed(3)}}</span>
    </resize-table>
  </a-modal>
</template>

<script>
import { formulaMixins } from '../unitls'
export default {
  mixins:[formulaMixins],
  mounted(){
    this.getList()
  },
  data(){
    return {
      overseasFlag: window.localStorage.getItem('overseasFlag'),
      downloading:false,
      tableLoading:false,
      columns:[
        { 
          dataIndex:'factoryName',
          title: '工厂',
          width: 120
        },
        {
          dataIndex:'animalTypeName',
          align:'center',
          title: '动物类型',
          width: 120
        },
         {
          dataIndex:'formulaName',
          title: '配方',
          width: 120
        },
        {
          dataIndex:'typeName',
          title: '原料类型',
          width: 120
        },
        {
          dataIndex:'rawName',
          title: '原料名称',
          width: 120,
          scopedSlots: {customRender: 'rawName'},
        },
        {
          dataIndex:'uasge',
          title: '用量（吨）',
          width: 120,
          align:'center',
          scopedSlots: {customRender: 'uasge'},
        },
      ]
    }
  },
  watch:{
    'visible.assess'(val){
      if(val) this.getList()
    }
  },
  methods:{
    async ok(){
      await this.download()
      this.$message.success('下载成功！')
    },

    getList(){
      return this.fetchGet({
        actions:this.selectTaskFormulaRawAssessPage,
        name:'list',
        loading:'tableLoading',
        data:{
          taskId:this.taskId,
          current:1,
          size:800
        }
      })
    },

    async download(){
      let aliasFlag = window.localStorage.getItem('overseasFlag') == 1 ? 1 : 0
      const res = await this.$http('/nhf-app/formulataskformularaw/exportTaskFormulaRawAssessPage',{params:{taskId:this.taskId,aliasFlag},responseType:'arraybuffer'})
      this.downloadExcel(res)
    },
    
    downloadExcel(file){
      new Promise((res,rej) => {
        this.downloading = true
        const {taskName,updateTime} =this.detail
        let blob = new Blob([file], { type:'application/vnd.ms-excel;charset=utf-8'})
        let objectUrl = URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = window.URL.createObjectURL(blob)
        a.download = `${taskName}-原料评估-${updateTime}.xlsx`;
        a.click() 
        window.URL.revokeObjectURL(a.href)
        objectUrl ? res(objectUrl) : rej(null)
      }).finally(()=>{
        this.downloading = false
      })
    }
  }
}
</script>

<style>

</style>